import { Button } from '@safe-global/views/components/ui/button'
import useConnectWallet from '@/components/common/ConnectWallet/useConnectWallet'
import { cn } from '@safe-global/views/utils/cn'

const ConnectWalletButton = ({
  onConnect,
  contained = true,
  variant,
  size = 'default',
  text,
  className,
  fullWidth = false,
}: {
  onConnect?: () => void
  contained?: boolean
  variant?: React.ComponentProps<typeof Button>['variant']
  size?: React.ComponentProps<typeof Button>['size']
  text?: string
  className?: string
  fullWidth?: boolean
}): React.ReactElement => {
  const connectWallet = useConnectWallet()

  const handleConnect = () => {
    onConnect?.()
    connectWallet()
  }

  return (
    <Button
      data-testid="connect-wallet-btn"
      onClick={handleConnect}
      variant={variant ?? (contained ? 'default' : 'ghost')}
      size={size}
      className={cn(fullWidth && 'w-full', className)}
    >
      {text || 'Connect'}
    </Button>
  )
}

export default ConnectWalletButton
